<template>
  <div id="app">
    <div class="l-container">
      <transition name="fade">
        <router-view/>
      </transition>
      <div class="nav-wrapper">
        <Navigation />
        <Player />
        <!--<Cookies v-if="cookie == false"></Cookies>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import Navigation from '@/components/Navigation'
import Player from '@/components/Player'
import Cookies from '@/components/Cookies'

export default {
  name: 'App',
  computed: {
    ...mapGetters(['getCookies', 'getPlayer']),
    cookie () {
      return this.getCookies
    },
    track () {
      return this.getPlayer
    }
  },
  components: {
    Navigation,
    Cookies,
    Player
  }
}
</script>

<style>
body {
  background: #fff;
  color: #000;
}

.nav-wrapper {
    position: absolute;
    bottom: 0;
}

@media all and (max-width: 600px) {
  .nav-wrapper {
      position: fixed;
      bottom: initial;
      top: 0;
  }
}

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .10s;
}

.fade-enter-active {
  transition-delay: .10s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}
</style>

<style src='./assets/scss/styles.scss' lang='scss' />



// WEBPACK FOOTER //
// src/App.vue